

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AtlasCheckoutInfo extends Vue {
  name = 'AtlasCheckoutInfo';

  @Prop({ type: Number, default: 10 }) readonly slots: number;

  getExpansionServers(): number {
    const expansionServers: number = Math.floor(this.slots / 10 - 1);
    return expansionServers > 15 ? 15 : expansionServers;
  }

  getSlotsPerExpansionServer(): number {
    return Math.floor(this.slots / (this.getExpansionServers() + 1));
  }
}
